import React, { Component } from "react";

export default class BoosterService extends Component {
  render() {
    const { img, name, tags } = this.props;

    return (
      <div className="col-sm-4 allSkills">
        <div className="img-box">
          <div className="heading-container">
            <img src={img} alt />
            <div className="skillNameWrap">
              <h2>{name}</h2>
            </div>
          </div>
          <div className="separator-line bg-white" />
        </div>
        <p
          dangerouslySetInnerHTML={{
            __html: tags
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BoosterService/index.js